import {
    copy,
    DownArrowBlack,
    email,
    filterBlack,
    MoveIcon,
    telephone,
    UpArrowBlack,
} from '@/assets'
import {
    Button,
    DateRange,
    IconWrapper,
    Modal,
    MultiSelect,
    MultiSelectNoInput,
} from '@/components/Atoms'
import MultiSelectPopUp from '@/components/Atoms/MultiSelectPopup'
import { DateRangeType } from '@/components/survey/SurveyModel/types/commonTypes'
import {
    DropDownOption,
    IPoaModalItem,
} from '@/components/survey/SurveyModel/types/nodeTypes'
import TriageListModal from '@/components/TriageComponents/TriageListModal/index'
import {
    ListTypes,
    WaitingListRecordStatuses,
} from '@/constants/enums'
import { RootState } from '@/reducers/store'
import {
    useGetAnae,
    useGetHospitals,
    useGetIntendedManagement,
    useGetNameChiOptions,
    useGetNameOpcs4OperationsOptions,
    useGetPriorities,
    useGetSpecialities,
    useGetSurgeons,
    useGetTriageListData,
    useResetAllPoaSurveyLists,
    useResetNameChi,
    useResetOperationProcedures,
} from '@/state/survey/poaSurveySlice'
import copyToClipboard from 'copy-to-clipboard'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { debounce } from 'lodash'
import moment from 'moment'
import React, { memo, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { MultiValue } from 'react-select'

interface Header {
    title: string
    code: string
    icons: string[]
    sortKey?: string
    border?: boolean
    menuPositionOffset?: {
        top?: string
        left?: string
        transform?: string
        minWidth?: string
    }
}

dayjs.extend(utc)

const TriageList: React.FC = memo(() => {
    interface Option {
        value: string
        label: string
    }

    interface FilterMap {
        specialities: MultiValue<Option> | null
        surgeons: MultiValue<Option> | null
        priority: MultiValue<Option> | null
        anae: MultiValue<Option> | null
        nameChi: MultiValue<Option> | null
        operationProcedures: MultiValue<Option> | null
        questionnaire: MultiValue<Option> | null
        requested: MultiValue<Option> | null
        ipDsu: MultiValue<Option> | null
        hospital: MultiValue<Option> | null
    }

    /// Start: triage type model
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [sendModalOpen, setSendModalOpen] = useState(false)
    const [questionnaireResponseId, setQuestionnaireResponseId] = useState(0)
    const [waitingListRecordId, setWaitingListRecordId] = useState(0)
    const [name, setName] = useState('')
    /// End: triage type model
    const {
        specialities,
        surgeons,
        priorities,
        anae,
        poaData,
        nameChi,
        operationProcedures,
        triageListData,
        intendedManagement,
        hospitals,
    } = useSelector((state: RootState) => state.poaSurvey)
    const [specialityOptions, setSpecialityOptions] = useState<
        DropDownOption[]
    >([])
    const [surgeonOptions, setSurgeonOptions] = useState<DropDownOption[]>([])
    const [priorityOptions, setPriorityOptions] = useState<DropDownOption[]>([])
    const [anaeOptions, setAnaeOptions] = useState<DropDownOption[]>([])
    const [nameChiOptions, setNameChiOptions] = useState<DropDownOption[]>([])
    const [operationProcedureOptions, setOperationProcedureOptions] = useState<
        DropDownOption[]
    >([])
    const [ipDsuOptions, setIpDsuOptions] = useState<DropDownOption[]>([])
    const [hospitalOptions, setHospitalOptions] = useState<DropDownOption[]>([])
    const [selectedHospital, setSelectedHospital] = useState<FilterMap['hospital']>(null)
    const [nameChiSearchInput, setNameChiSearchInput] = useState('');
    const [opcsSearchInput, setOpcsSearchInput] = useState('');

    const questionnaireOptions: DropDownOption[] = [
        { value: '0', label: 'All' },
        { value: 'null', label: 'Not sent' },
        { value: '1', label: 'Sent - Not started' },
        { value: '2', label: 'Started' },
        { value: '3', label: 'Submitted' },
    ]
    const statusOptions: DropDownOption[] = [
        { value: '0', label: 'All' },
        { value: '2', label: 'In progress' },
        { value: '3', label: 'Complete' },
        { value: '4', label: 'Expired' },
    ]

    const requestedOptions: DropDownOption[] = [
        { value: '0', label: 'All' },
        { value: '1', label: 'Yes' },
        { value: '2', label: 'No' },
    ];

    const [activeFilterKey, setActiveFilterKey] = useState<string | null>(null)

    const [selectedSpecialities, setSelectedSpecialities] =
        useState<FilterMap['specialities']>(null)
    const [selectedSurgeons, setSelectedSurgeons] =
        useState<FilterMap['surgeons']>(null)
    const [selectedPriorities, setSelectedPriorities] = useState<
        FilterMap['priority']
    >([])
    const [selectedAnae, setSelectedAnae] = useState<FilterMap['anae']>([])
    const [selectedNameChi, setSelectedNameChi] =
        useState<FilterMap['nameChi']>(null)
    const [selectedOperationProcedures, setSelectedOperationProcedures] = useState<FilterMap['operationProcedures']>(null)
    const [selectedQuestionnaire, setSelectedQuestionnaire] = useState<FilterMap['questionnaire']>(null)
    const [selectedRequested, setSelectedRequested] = useState<FilterMap['requested']>(null)
    const [selectedIpDsu, setSelectedIpDsu] = useState<FilterMap['ipDsu']>(null)
    const [selectedScheduledDateRange, setSelectedScheduledDateRange] =useState<DateRangeType | null>(null)

    const [sortByColumn, setSortByColumn] = useState<string | null>(null)
    const [sortOrder, setSortOrder] = useState<'asc' | 'desc' | null>(null)

    const shouldRunPoaDataEffect = useRef(false)

    const getTriageListData = useGetTriageListData()
    const getSpecialities = useGetSpecialities()
    const getSurgeons = useGetSurgeons()
    const getHospitalsList = useGetHospitals()
    const getPriorities = useGetPriorities()
    const resetNameChi = useResetNameChi()
    const resetOpcs = useResetOperationProcedures()
    const getAnae = useGetAnae()
    const getNameOpcs4OperationsOptions = useGetNameOpcs4OperationsOptions()
    const getNameChiOptions = useGetNameChiOptions()
    const resetAllLists = useResetAllPoaSurveyLists()
    const getIntendedManagementOptions = useGetIntendedManagement()

    const handleFilterChange = (
        type: keyof FilterMap,
        selected: MultiValue<Option>
    ) => {
        switch (type) {
            case 'specialities':
                setSelectedSpecialities(selected)
                break
            case 'surgeons':
                setSelectedSurgeons(selected)
                break
            case 'priority':
                setSelectedPriorities(selected)
                break
            case 'anae':
                setSelectedAnae(selected)
                break
            case 'nameChi':
                setSelectedNameChi(selected)
                break
            case 'operationProcedures':
                setSelectedOperationProcedures(selected)
                break
            case 'questionnaire':
                setSelectedQuestionnaire(selected)
                break
            case 'requested':
                setSelectedRequested(selected)
                break
            case 'ipDsu':
                setSelectedIpDsu(selected)
                break
            case 'hospital':
                setSelectedHospital(selected)
                break
        }
    }

    useEffect(() => {
        if (activeFilterKey !== 'operationDate') {
            return
        }

        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as HTMLElement | null
            if (!target) return

            if (target.closest('.date-picker-popup')) {
                return
            }

            if (target.closest('.filter-icon-wrap')) {
                return
            }

            setActiveFilterKey(null)
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [activeFilterKey])

    useEffect(() => {
        getSpecialities(ListTypes.TriageList)
        getSurgeons(ListTypes.TriageList)
        getPriorities(ListTypes.TriageList)
        getAnae(ListTypes.TriageList)
        getIntendedManagementOptions()
        getHospitalsList()
        getTriageListData(
            [], //speciality
            [], //surgon
            selectedPriorities?.map((s) => Number(s.value)), //priorityIds
            [], //CHIs
            [], //operationProcedureIds
            selectedAnae?.map((s) => Number(s.value)), //anaestheticTypeIds
            [WaitingListRecordStatuses.Initial], //waitingListRecordStatusIds
            [], //questionnaireStatusId
            [],
            sortByColumn,
            sortOrder,
            undefined,
            undefined,
            undefined
            
        )
        return () => {
            resetAllLists()
            setIsModalOpen(false)
            setSendModalOpen(false)
            setQuestionnaireResponseId(0)
            setWaitingListRecordId(0)
            setName('')
            setActiveFilterKey(null)
            setSelectedSpecialities(null)
            setSelectedSurgeons(null)
            setSelectedPriorities([])
            setSelectedAnae([])
            setSelectedNameChi(null)
            setSelectedOperationProcedures(null)
            setSelectedQuestionnaire(null)
            setSelectedRequested(null)
            setSelectedIpDsu(null)
            setSortByColumn(null)
            setSortOrder(null)
            setSelectedScheduledDateRange(null)
            setSelectedHospital(null)
        }
    }, [])

    useEffect(() => {
        return () => {
            setNameChiSearchInput('');
            setOpcsSearchInput('');
        };
    }, []);

    useEffect(() => {
        // Reset states when route changes
        setIsModalOpen(false)
        setSendModalOpen(false)
        setSelectedSpecialities(null)
        setSelectedSurgeons(null)
        resetAllLists()
    }, [location.pathname])

    useEffect(() => {
        if (!specialities?.length) return
        setSpecialityOptions([
            { value: '0', label: 'All specialities' },
            ...specialities.map(
                ({ id, name }): DropDownOption => ({
                    value: id,
                    label: name,
                })
            ),
        ])
    }, [specialities])

    useEffect(() => {
        if (!surgeons?.length) return
        setSurgeonOptions([
            { value: '0', label: 'All surgeons' },
            ...surgeons.map(
                ({ id, name }): DropDownOption => ({
                    value: id,
                    label: name,
                })
            ),
        ])
    }, [surgeons])

    useEffect(() => {
        if (!priorities?.length) return
        setPriorityOptions([
            { value: '0', label: 'All' },
            ...priorities.map(
                ({ id, name }): DropDownOption => ({
                    value: id,
                    label: name,
                })
            ),
        ])
    }, [priorities])

    useEffect(() => {
        if (!anae?.length) return
        setAnaeOptions([
            { value: '0', label: 'All' },
            ...anae.map(
                ({ id, code }): DropDownOption => ({
                    value: id,
                    label: code,
                })
            ),
        ])
    }, [anae])

    useEffect(() => {
        let chiOptions: any[] = []
        if (nameChi?.length) {
            chiOptions = [...nameChi]
        }
        if (selectedNameChi && selectedNameChi.length) {
            //chiOptions = [...new Set([...chiOptions, ...selectedNameChi])]
            const merged = [...chiOptions, ...selectedNameChi]
            chiOptions = Array.from(
                new Map(merged.map((item) => [item.value, item])).values()
            )
        }
        setNameChiOptions(chiOptions)

        if (!nameChi?.length) return
    }, [nameChi, selectedNameChi])


    useEffect(() => {
        if (!intendedManagement?.length) return
        setIpDsuOptions(
            intendedManagement.map(({ id, code }) => ({
                value: String(id),
                label: code,
            }))
        )
    }, [intendedManagement])

    useEffect(() => {
        if (!hospitals?.length) return
        setHospitalOptions(
            hospitals.map(({ id, name }) => ({
                value: String(id),
                label: name,
            }))
        )
    }, [hospitals])

    useEffect(() => {
        let opcOptions: any[] = [];
        
        if (operationProcedures?.length) {
            const mergedOpcOptions = [
                ...operationProcedures.map(({ id, code, name }): any => ({
                    value: id,
                    label: code + ' - ' + name,
                })),
            ];
            opcOptions = [...mergedOpcOptions];
        }
    
        if (selectedOperationProcedures?.length) {
            const merged = [...opcOptions, ...selectedOperationProcedures];
            opcOptions = Array.from(new Map(merged.map((item) => [item.value, item])).values());
        }
        
        setOperationProcedureOptions(opcOptions);
        if (!operationProcedures?.length) return
    }, [operationProcedures, selectedOperationProcedures]);

    const getRequestedApiValues = (): boolean[] | undefined => {
        if (!selectedRequested?.length) {
            return undefined
        }

        if (selectedRequested.some((option) => String(option.value) === '0')) {
            return [true, false]
        }

        const requestedValues = selectedRequested
            .map((option) => {
                const optionValue = String(option.value)
                if (optionValue === '1') return true
                if (optionValue === '2') return false
                return null
            })
            .filter((value): value is boolean => value !== null)

        return Array.from(new Set(requestedValues))
    }

    useEffect(() => {
        const debounced = debounce(() => {
            if (shouldRunPoaDataEffect.current) {
                getTriageListData(
                    selectedSpecialities?.map((s) => Number(s.value)) ?? [],
                    selectedSurgeons?.map((s) => Number(s.value)) ?? [],
                    selectedPriorities?.map((s) => Number(s.value)),
                    selectedNameChi?.map((item) => item.value),
                    selectedOperationProcedures?.map((s) => Number(s.value)),
                    selectedAnae?.map((s) => Number(s.value)),
                    [WaitingListRecordStatuses.Initial], //waitingListRecordStatusIds
                    selectedQuestionnaire?.map((s) => Number(s.value)),
                    getRequestedApiValues(),
                    sortByColumn,
                    sortOrder,
                    selectedScheduledDateRange?.start ? new Date(selectedScheduledDateRange.start) : undefined,
                    selectedScheduledDateRange?.end ? new Date(selectedScheduledDateRange.end) : undefined,
                    selectedIpDsu?.map((s) => Number(s.value)) ?? [],
                    selectedHospital?.map((s) => Number(s.value)) ?? [],
                )
            } else {
                shouldRunPoaDataEffect.current = true
            }
        }, 500)
        debounced()
        return () => debounced.cancel()
    }, [
        selectedSpecialities,
        selectedSurgeons,
        selectedPriorities,
        selectedAnae,
        selectedNameChi,
        selectedOperationProcedures,
        selectedQuestionnaire,
        sortByColumn,
        sortOrder,
        selectedRequested,
        selectedScheduledDateRange,
        selectedIpDsu,
        selectedHospital
    ])

    const toggleSort = (column: string | undefined) => {
        if (!column) {
            return
        }
        if (sortByColumn === column) {
            if (sortOrder === 'asc') {
                setSortOrder('desc')
            } else if (sortOrder === 'desc') {
                setSortByColumn(null)
                setSortOrder(null)
            } else {
                setSortOrder('asc')
            }
        } else {
            setSortByColumn(column)
            setSortOrder('asc')
        }
    }

    const openModal = () => setIsModalOpen(true)
    const closeModal = (poaModalItem: IPoaModalItem | null) => {
        if (poaModalItem) {
            const found: any = poaData.find(
                (item: any) => item.id === poaModalItem.id
            )
            if (found) {
                found.questionnaireResponsePOADateTime =
                    poaModalItem.poaDateTime
                found.questionnaireResponsePOAType = poaModalItem.poaType
            }
        }
        setIsModalOpen(false)
    }

    const getSelectedValue = (code: string): MultiValue<Option> => {
        switch (code) {
            case 'priority':
                return selectedPriorities ?? []
            case 'anae':
                return selectedAnae ?? []
            case 'nameChi':
                return selectedNameChi ?? []
            case 'questionnaire':
                return selectedQuestionnaire ?? []
            case 'requested':
                return selectedRequested ?? []
            case 'ipDsu':
                return selectedIpDsu ?? []
            case 'hospital':
                return selectedHospital ?? []
            default:
                return []
        }
    }

    const headers: Header[] = [
        {
            title: 'Priority',
            code: 'priority',
            icons: ['filter', 'sortBy'],
            sortKey: 'Priority',
            menuPositionOffset: {
                top: '11px',
                left: '-60px',
                minWidth: '160px',
            },
        },
        {
            title: 'Name/CHI',
            code: 'nameChi',
            icons: ['filter'],
            sortKey: 'Name',
            menuPositionOffset: {
                top: '12px',
                left: '-85px'
            },
        },
        {
            title: 'OPCS-4/operation',
            code: 'operationProcedures',
            icons: ['filter'],
            sortKey: 'OPCSCode',
            menuPositionOffset: {
                top: '12px',
                left: '-136px'
            },
        },
        {
            title: 'Scheduled',
            code: 'operationDate',
            icons: ['filter', 'sortBy'],
            sortKey: 'Scheduled',
            menuPositionOffset: { top: '20px', left: '-81px' },
        },
        {
            title: 'Hospital',
            code: 'hospital',
            icons: ['filter'],
            menuPositionOffset: {
                top: '11px',
                left: '-66px',
                minWidth: '160px',
            },
        },
        {
            title: 'Anae',
            code: 'anae',
            icons: ['filter'],
            sortKey: 'Anae',
            menuPositionOffset: {
                top: '11px',
                left: '-46px',
                minWidth: '160px',
            },
        },
        {
            title: "IP/DSU",
            code: 'ipDsu',
            icons: ['filter'],
            border: true,
            menuPositionOffset: {
                top: '11px',
                left: '-62px',
                minWidth: '160px',
            },
        },
        {
            title: 'Requested',
            code: 'requested',
            icons: ['filter'],
            sortKey: 'Requested',
            menuPositionOffset: {
                top: '11px',
                left: '-82px',
                minWidth: '160px',
            },
        },
        { title: 'Move to POA', code: 'date', icons: [] },
    ]

    const [hoveredTitle, setHoveredTitle] = useState<string | null>(null)

    const handleToggleFilter = (type: string) => {
        setActiveFilterKey((prev) => (prev === type ? null : type))
    }

    const getOptionsByCode = (code: string): DropDownOption[] => {
        switch (code) {
            case 'priority':
                return priorityOptions
            case 'anae':
                return anaeOptions
            case 'questionnaire':
                return questionnaireOptions
            case 'poaStatuses':
                return statusOptions
            case 'nameChi':
                return nameChiOptions
            case 'operationProcedures':
                return operationProcedureOptions
            case 'requested':
                return requestedOptions
            case 'ipDsu':
                return ipDsuOptions
            case 'hospital':
                return hospitalOptions
            default:
                return []
        }
    }

    const handleNameChiSearch = (value: string) => {
        const trimmedValue = value.trim()
        if (!trimmedValue) {
            resetNameChi()
        }
        if (trimmedValue.length >= 10) {
            getNameChiOptions(trimmedValue, ListTypes.TriageList)
        }
    }

    const handleOpcsSearch = (value: string) => {
        const trimmedValue = value.trim()
        if (trimmedValue) {
            getNameOpcs4OperationsOptions(ListTypes.TriageList, trimmedValue)
        } else {
            resetOpcs()
        }
    }

    const handleSearchInputTextChange = (type: string, value: string) => {
        switch (type) {
            case 'nameChi':
                handleNameChiSearch(value)
                break
            case 'operationProcedures':
                handleOpcsSearch(value)
                break
        }
    }

    const isFilterApplied = (code: string): boolean => {
        switch (code) {
            case 'priority':
                return !!selectedPriorities?.length
            case 'anae':
                return !!selectedAnae?.length
            case 'nameChi':
                return !!selectedNameChi?.length
            case 'questionnaire':
                return !!selectedQuestionnaire?.length
            case 'operationProcedures':
                return !!selectedOperationProcedures?.length
            case 'requested':
                return !!selectedRequested?.length
            case 'ipDsu':
                return !!selectedIpDsu?.length
            case 'hospital':
                return !!selectedHospital?.length
            default:
                return false
        }
    }

    const isColumnSorted = (columnCode: string): boolean => {
        switch (columnCode) {
            case 'priority':
                return sortByColumn === 'Priority'
            case 'nameChi':
                return sortByColumn === 'Name'
            case 'operationProcedures':
                return sortByColumn === 'OPCSCode'
            case 'anae':
                return sortByColumn === 'Anae'
            case 'operationDate':
                return sortByColumn === 'Scheduled'
            case 'ttg':
                return sortByColumn === 'TTG'
            case 'date':
                return sortByColumn === 'Date'
            case 'questionnaire':
                return sortByColumn === 'questionnaire'
            default:
                return false
        }
    }

    const handleSelectedScheduledDateRange = (dateRange: DateRangeType | null) => {
        if (dateRange) {
            dateRange.start = moment(dateRange.start, 'DD-MM-YYYY').format('YYYY-MM-DD')
            dateRange.end = moment(dateRange.end, 'DD-MM-YYYY').format('YYYY-MM-DD')
            setSelectedScheduledDateRange(dateRange)
            setActiveFilterKey(null)
        } else {
            setSelectedScheduledDateRange(null)
            setActiveFilterKey(null)
        }
    }

    return (
        <div className="triage-list-wrapper">
            <div className="triage-inner-wrapper">
            <div>
                <h1 className="triage-list-header">Patient list</h1>
            </div>

            <div className="triage-filters-wrapper">
                <div className="triage-filters">
                    <div className="poa-filters-search-wrapper">
                        <div className="relative w-full h-full">
                            {/* Top filters */}
                            <MultiSelect
                                options={specialityOptions}
                                handleChange={(selected: MultiValue<Option>) =>
                                    handleFilterChange('specialities', selected)
                                }
                                value={selectedSpecialities}
                                isInvalid={false}
                                placeholder={'Speciality'}
                                shouldSelectAllDefault={true}
                                key={4}
                            />
                        </div>
                    </div>

                    <div className="triage-filters-search-wrapper">
                        <div className="relative w-full h-full">
                            <MultiSelect
                                options={surgeonOptions}
                                handleChange={(selected: MultiValue<Option>) =>
                                    handleFilterChange('surgeons', selected)
                                }
                                value={selectedSurgeons}
                                isInvalid={false}
                                placeholder={'Surgeon'}
                                shouldSelectAllDefault={true}
                                key={5}
                            />
                        </div>
                    </div>

                    <div className="triage-filters-search-wrapper"></div>
                </div>

                <div className="triage-table-header">
                    <div className="triage-table-header-columns">
                        {headers.map((header) => (
                            <div
                                key={header.code}
                                className={`triage-table-header-column flex items-center justify-start ${header.border ? 'links-column' : ''}`}
                            >
                                <span
                                    onMouseEnter={() =>
                                        setHoveredTitle(`filter-${header.code}`)
                                    }
                                    onMouseLeave={() => setHoveredTitle(null)}
                                    className="triage-table-header-title"
                                >
                                    {header.title}
                                </span>
                                {header.icons.map((icon, i) =>
                                    icon === 'filter' ? (
                                        <div key={i} className="shrink-0">
                                            <div
                                                className={`filter-icon-wrap ${isFilterApplied(header.code) ? 'sort-filter-applied' : ''} ${hoveredTitle === `filter-${header.code}` ? 'hover-filter-applied' : ''}`}
                                                onMouseEnter={() =>
                                                    setHoveredTitle(`filter-${header.code}`)
                                                }
                                                onMouseLeave={() =>
                                                    setHoveredTitle(null)
                                                }
                                            >
                                                <img
                                                    key={i}
                                                    src={filterBlack}
                                                    alt="Icon"
                                                    className="header-icons cursor-pointer"
                                                    onClick={() =>
                                                        handleToggleFilter(
                                                            header.code
                                                        )
                                                    }
                                                />
                                            </div>

                                            {activeFilterKey === header.code && (
                                                <div className="absolute">
                                                    {header.code ===
                                                        'nameChi' ||
                                                    header.code ===
                                                        'operationProcedures' ? (
                                                        <MultiSelectPopUp
                                                            {...(header.menuPositionOffset && {
                                                                menuPositionOffset:
                                                                    header.menuPositionOffset,
                                                            })}
                                                            inputValue={
                                                                header.code ===
                                                                'nameChi'
                                                                    ? nameChiSearchInput
                                                                    : opcsSearchInput
                                                            }
                                                            onInputValueChange={(
                                                                value: any
                                                            ) => {
                                                                if (
                                                                    header.code ===
                                                                    'nameChi'
                                                                ) {
                                                                    setNameChiSearchInput(
                                                                        value
                                                                    )
                                                                } else if (
                                                                    header.code ===
                                                                    'operationProcedures'
                                                                ) {
                                                                    setOpcsSearchInput(
                                                                        value
                                                                    )
                                                                }
                                                            }}
                                                            id={
                                                                header.code ===
                                                                'nameChi'
                                                                    ? 'filternamechi'
                                                                    : header.code ===
                                                                        'operationProcedures'
                                                                      ? 'operationprocedures'
                                                                      : ''
                                                            }
                                                            headerCode={
                                                                header.code
                                                            }
                                                            isInValid={false}
                                                            propDivClasses={
                                                                header.code ===
                                                                'nameChi'
                                                                    ? 'filter-name-chi'
                                                                    : header.code ===
                                                                        'operationProcedures'
                                                                      ? 'filter-opcs-4-operation'
                                                                      : ''
                                                            }
                                                            handleCustomSearchInputTextChange={(
                                                                textValue: string
                                                            ) => {
                                                                handleSearchInputTextChange(
                                                                    header.code,
                                                                    textValue
                                                                )
                                                            }}
                                                            handleChange={(
                                                                selected: MultiValue<Option>
                                                            ) =>
                                                                handleFilterChange(
                                                                    header.code as keyof FilterMap,
                                                                    selected
                                                                )
                                                            }
                                                            handleFilterChange={
                                                                handleFilterChange
                                                            }
                                                            value={
                                                                header.code ===
                                                                'nameChi'
                                                                    ? selectedNameChi
                                                                    : header.code ===
                                                                        'operationProcedures'
                                                                      ? selectedOperationProcedures
                                                                      : []
                                                            }
                                                            options={getOptionsByCode(
                                                                header.code
                                                            )}
                                                        />
                                                    ) : header.code === 'operationDate' ? 
                                                        (
                                                        <div
                                                            className="date-picker-popup"
                                                            style={{
                                                                ...(header.menuPositionOffset?.top
                                                                    ? {
                                                                          top: header
                                                                              .menuPositionOffset
                                                                              .top,
                                                                      }
                                                                    : {}),
                                                                ...(header.menuPositionOffset?.left
                                                                    ? {
                                                                          left: header
                                                                              .menuPositionOffset
                                                                              .left,
                                                                      }
                                                                    : {}),
                                                                ...(header.menuPositionOffset?.transform
                                                                    ? {
                                                                          transform: `${header.menuPositionOffset.transform} translateY(-5px)`,
                                                                      }
                                                                    : {
                                                                          transform:
                                                                              'translateY(-6px)',
                                                                      }),
                                                                ...(header.menuPositionOffset?.minWidth
                                                                    ? {
                                                                          minWidth: header
                                                                              .menuPositionOffset
                                                                              .minWidth,
                                                                      }
                                                                    : {}),
                                                            }}
                                                        >
                                                            <DateRange
                                                                initialDate={
                                                                    (selectedScheduledDateRange as DateRangeType) ??
                                                                    null
                                                                }
                                                                name={''}
                                                                onChange={
                                                                    (dateRange) => handleSelectedScheduledDateRange(dateRange)
                                                                }
                                                                propClasses={''}
                                                                calendarWidth={336}
                                                                isPatient={false}
                                                                defaultCalendarOpen
                                                            />
                                                        </div>
                                                    )
                                                    :(
                                                        <MultiSelectNoInput
                                                            {...(header.menuPositionOffset && {
                                                                menuPositionOffset:
                                                                    header.menuPositionOffset,
                                                            })}
                                                            handleChange={(
                                                                selected: MultiValue<Option>
                                                            ) => {
                                                                handleFilterChange(
                                                                    header.code as keyof FilterMap,
                                                                    selected
                                                                )
                                                            }}
                                                            value={
                                                                getSelectedValue(
                                                                    header.code
                                                                ) || []
                                                            }
                                                            options={getOptionsByCode(
                                                                header.code
                                                            )}
                                                            keepMenuOpen={true}
                                                            isOpen={
                                                                activeFilterKey ===
                                                                header.code
                                                            }
                                                            onClose={() =>
                                                                setActiveFilterKey(
                                                                    null
                                                                )
                                                            }
                                                        />
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div
                                            className={`shrink-0 flex flex-col sort-icon sort-icon-wrap cursor-pointer ${hoveredTitle === `sort-${header.code}` ? 'hover-filter-applied' : ''}`}
                                            onMouseEnter={() =>
                                                setHoveredTitle(`sort-${header.code}`)
                                            }
                                            onMouseLeave={() =>
                                                setHoveredTitle(null)
                                            }
                                            onClick={() =>
                                                toggleSort(header.sortKey)
                                            }
                                        >
                                            <div className="sort-arrow-up-spacing">
                                                <UpArrowBlack
                                                    className={`${isColumnSorted(header.code) && sortOrder === 'desc' ? 'arrow-dimmed' : 'arrow-bright'}`}
                                                />
                                            </div>
                                            <div className="sort-arrow-down-spacing">
                                                <DownArrowBlack
                                                    className={`${isColumnSorted(header.code) && sortOrder === 'asc' ? 'arrow-dimmed' : 'arrow-bright'}`}
                                                />
                                            </div>
                                        </div>
                                    )
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="triage-body-wrapper">
                {triageListData?.length > 0 &&
                    triageListData.map((triageItem: any, index: number) => (
                        <>
                            <div
                                className={`triage-table-body ${index === 0 ? 'first-row' : ''}`}
                            >
                                <div className="triage-table-body-column">
                                    {triageItem.priority}
                                </div>
                                <div className="triage-table-body-column">
                                    <div
                                        style={{ fontWeight: 600 }}
                                    >{` ${triageItem.surname}, ${triageItem.forename}`}</div>
                                    <div>{triageItem.chiNumber}</div>
                                    <div className="flex items-center gap-2">
                                        <img src={telephone} alt="Phone Icon" />
                                        <span>{triageItem.mobileNumber}</span>
                                    </div>
                                    <div className="group flex items-center gap-2 min-w-0">
                                        <img
                                            src={email}
                                            alt="Email Icon"
                                            className="flex-shrink-0"
                                        />
                                        <span className="truncate">
                                            {triageItem.email}
                                        </span>
                                        {triageItem.email && (
                                            <img
                                                src={copy}
                                                alt="Copy Email"
                                                className="flex-shrink-0 cursor-pointer opacity-0 transition-opacity duration-150 group-hover:opacity-100"
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    copyToClipboard(
                                                        triageItem.email
                                                    )
                                                }}
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="triage-table-body-column">
                                    {triageItem?.opcsCode +
                                        ' - ' +
                                        triageItem.operationProcedure}
                                </div>
                                 <div className="triage-table-body-column">
                                    {triageItem.operationDate 
                                        ? dayjs.utc(triageItem.operationDate).local().format('DD/MM/YYYY')
                                        : '--'
                                    }
                                </div>
                                <div className="triage-table-body-column">
                                    {triageItem.hospitalName || '--'}
                                </div>
                                <div className="triage-table-body-column">
                                    {triageItem.anaestheticType}
                                </div>
                                <div className="triage-table-body-column show-border">
                                    {triageItem.intendedManagementReferenceCode || '--'}
                                </div>
                                <div className="triage-table-body-column">
                                    {triageItem.requested ? 'Yes': 'No'}
                                </div>
                                <div className="triage-table-body-column flex">
                                    <div className="move-to-poa-icons-wrapper">
                                        <IconWrapper icon={<MoveIcon />} hoveredIcon={<MoveIcon color="#fff" />} className='move-to-poa' onClick={() => {
                                            setQuestionnaireResponseId(
                                                triageItem.questionnaireResponseId
                                            )
                                            setWaitingListRecordId(
                                                triageItem.id
                                            )
                                            setName(
                                                `${triageItem.surname}, ${triageItem.forename}`
                                            )
                                            openModal()
                                        }} />
                                    </div>
                                </div>
                            </div>
                            {index !== triageListData.length - 1 && <div className="divider"></div>}
                        </>
                    ))}
            </div>
            <TriageListModal
                isOpen={isModalOpen}
                onClose={closeModal}
                name={name}
                questionnaireResponseId={questionnaireResponseId}
                waitingListRecordId={waitingListRecordId}
                existingPOADateTime={undefined}
                submitButtonText="Move patient to POA"
                type={ListTypes.TriageList}
            />

            <Modal
                propClasses="worning"
                isOpen={sendModalOpen}
                setClose={() => {}}
            >
                <div className='triage-list-warning-modal'>
                    {' '}
                    You are not able to send the patient a questionnaire as the
                    patient does not have an email address. Add an email to your
                    EHR system and try again.{' '}
                </div>
                <div className="button-container">
                    <Button
                        type="primary"
                        text="OK"
                        icon={false}
                        handleClick={() => {
                            setSendModalOpen(false)
                        }}
                        stateProp="enabled"
                    />
                </div>
            </Modal>
        </div>
        </div>
    )
})

export default TriageList
